import { FormattedMessage } from 'react-intl';

const BubblesAlerts = () => {
	return (
		<article id="bubbles-alerts" className="bubbles">
			<div className="left-side">
				<span id="bubbles-alerts-1" className="bubble">
					<FormattedMessage id="bubbles-alerts-1" />
				</span>
			</div>
			<div className="right-side">
				<span id="bubbles-alerts-2" className="bubble">
					<FormattedMessage id="bubbles-alerts-2" />
				</span>
				<span id="bubbles-alerts-3" className="bubble">
					<FormattedMessage id="bubbles-alerts-3" />
				</span>
				<span id="bubbles-alerts-4" className="bubble">
					<FormattedMessage id="bubbles-alerts-4" />
				</span>
			</div>
		</article>
	);
};

export default BubblesAlerts;
